import { LightningElement, api } from "lwc";

class segmentedControlItem extends LightningElement {
  @api label = null;
  @api value = null;
  @api href = null;
  connectedCallback() {
    this.dispatchEvent(
      new CustomEvent("privateitemregister", {
        cancelable: true,
        bubbles: true,
        composed: true,
        detail: {
          href: this.href,
          label: this.label,
          value: this.value || this.href,
          role: this.href ? "link" : "button",
        },
      })
    );
  }
}

export default segmentedControlItem;
